// Usage management service

class UsageService {
  /**
   * Get user's subscription usage status
   * @param {string} userId - The user ID to check
   * @returns {Promise<Object>} User usage data or null if no active usage
   */
  async getUserUsageStatus(userId) {
    try {
      const response = await fetch(
        // `http://localhost:3001/v1/usage/user/${userId}`,
        `https://skyhost.ai/get-usage/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }

      const result = await response.json();

      if (!result.status) {
        throw new Error(result.message || "Failed to fetch user usage status");
      }

      return result;
    } catch (error) {
      console.error("Error fetching user usage status:", error);
      throw error;
    }
  }

  /**
   * Grant usage minutes to a user
   * @param {Object} payload - Grant details
   * @param {string} payload.userId - User ID
   * @param {number} payload.minutes - Minutes to grant
   * @param {string} payload.usageId - Usage ID (optional, for existing usage)
   * @param {string} payload.reason - Reason for granting
   * @returns {Promise<Object>} Grant result
   */
  async grantUsageMinutes(payload) {
    try {
      const response = await fetch("https://skyhost.ai/grant-usage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }

      const result = await response.json();

      if (!result.status) {
        throw new Error(result.message || "Failed to grant usage minutes");
      }

      return result;
    } catch (error) {
      console.error("Error granting usage minutes:", error);
      throw error;
    }
  }
}

export const usageService = new UsageService();
export default usageService;
